import { FormCreate } from "../../types";

export const validation = (activity: FormCreate) => {
  let errors: { name: string, difficulty: string, duration: string, season: string, country: string[] } = {
    name: "",
    difficulty: "",
    duration: "",
    season: "",
    country: []
  };

  if (!activity.name) {
    errors.name = "Te faltó el Nombre!🤨";
  }

  if (!activity.difficulty) {
    errors.difficulty = "Selecciona la Dificultad!🤨";
  }

  if (!activity.duration) {
    errors.duration = "Selecciona la Duración!🤨";
  }

  if (!activity.season) {
    errors.season = "Selecciona la Temporada!🤨";
  }

  if (!activity.country.length) {
    errors.country = ["Debes elejir al menos un país!🤨"];
  }
  
  return errors;
};
